<template>
  <v-row class="mx-0">
    <v-col :md="vShowCalendar ? 4 : 12" class="py-0">
      <v-row>
        <v-col :md="vShowCalendar ? 12 : 8">
          <v-row class="custom-grey-border">
            <v-col
              md="12"
              class="light-gray-background custom-border-bottom d-flex justify-space-between"
            >
              <div
                style="font-size: 19px"
                class="text-uppercase font-weight-700 color-custom-blue"
              >
                Schedule
              </div>
              <div>
                <v-btn
                  class="mx-2 custom-bold-button white--text"
                  color="cyan"
                  right
                  small
                  :disabled="jobLoading"
                  depressed
                  v-on:click="updateCalendar()"
                >
                  <v-icon small class="mr-2">mdi-calendar-blank</v-icon>
                  <span v-if="vShowCalendar">Hide Calendar</span>
                  <span v-else>Show Calendar</span>
                </v-btn>
              </div>
            </v-col>
            <v-col :md="vShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-start-date"
                >Start Date</label
              >
              <DatePicker
                :allowed-dates="allowedDates"
                :disabled="jobLoading"
                key="visit-one-off-start-date"
                id="visit-one-off-start-date"
                placeholder="Start Date"
                :value="oneOffSchedule.start_date"
                v-on:change="
                  updateScheduleState('dbOneOffSchedule.start_date', $event);
                  updateScheduleState('dbOneOffSchedule.end_date', $event);
                "
              />
            </v-col>
            <v-col :md="vShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-start-time"
                >Start Time</label
              >
              <TimePicker
                :disabled="jobLoading"
                key="visit-one-off-start-time"
                id="visit-one-off-start-time"
                placeholder="Start Time"
                :value="oneOffSchedule.start_time"
                v-on:change="
                  updateScheduleState('dbOneOffSchedule.start_time', $event)
                "
                type="start-time"
              />
              <!--  <TimePicker
                :disabled="jobLoading"
                key="visit-one-off-start-time"
                id="visit-one-off-start-time"
                placeholder="Start Time"
                v-model="oneOffSchedule.start_time"
                :min-time="todayTime"
                v-on:change="
                  updateScheduleState(
                    'dbOneOffSchedule.start_time',
                    $event
                  ) 
                "
                type="start-time"
              /> -->
            </v-col>
            <v-col :md="vShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-end-time">End Time</label>
              <!-- <TimePicker
                :disabled="jobLoading"
                key="visit-one-off-end-time"
                id="visit-one-off-end-time"
                placeholder="End Time"
                v-model="oneOffSchedule.end_time"
                :min-time="updatedDate"
                v-on:change="
                  updateScheduleState('dbOneOffSchedule.end_time', $event)
                "
              /> -->
             
              <TimePicker
                :disabled="jobLoading"
                key="visit-one-off-end-time"
                id="visit-one-off-end-time"
                placeholder="End Time"
                :min-time="oneOffSchedule.start_time"
                :value="oneOffSchedule.end_time"
                v-on:change="
                  updateScheduleState('dbOneOffSchedule.end_time', $event)
                "
                type="end-time"
              />
            </v-col>
            <v-col md="12">
              <p
                class="m-0 p-4 font-size-16 font-weight-500 light-gray-background custom-grey-border"
              >
                This job will start on
                {{ formatDate(oneOffSchedule.start_date) }}
                {{ oneOffSchedule.start_time }} and finish on
                {{ formatDate(oneOffSchedule.end_date) }}
                {{ oneOffSchedule.end_time }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :md="vShowCalendar ? 12 : 4">
          <ScheduleTeam
            
            :schedule-key="scheduleKey"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="vShowCalendar" md="8">
      <Calendar
        :key="`job-one-off-calendar-${scheduleKey}`"
        :show-calendar="vShowCalendar"
      ></Calendar>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ScheduleTeam from "@/view/components/main-job/ScheduleTeam.vue";
import DatePicker from "@/view/components/main-job/QDatePicker.vue";
import TimePicker from "@/view/components/main-job/TimePicker.vue";
import Calendar from "@/view/pages/partials/Calendar.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";

import {
  UPDATE_DEFAULT_DATE,
  UPDATE_CALENDAR_ACTION,
  UPDATE_SCHEDULE_STATE,
} from "@/core/services/store/job.module";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "job-ctx-one-off-schedule",
  props: {
    vCustomerId: {
      type: Number,
      required: false,
    },
    holidays: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      todayDate: moment(new Date()).format("YYYY-MM-DD"),
      scheduleKey: Number(new Date()),
    };
  },
  // watch: {
  //    holidays: {
  //     handler() {
  //       // this.showErrorIfHoliday();
  //       // this.updateScheduleDatesToSkipHolidays();
  //     },
  //     immediate: true
  //   }
  // },

  methods: {
    // allowedDates(val) {
    //   console.log("holidays" , this.holidays);

    //   const date = new Date(val);
    //   return date.getDay() !== 0; // Allow only non-Sundays
    // },
    allowedDates(val) {
      const date = new Date(val);
      const dateString = moment(date).format("YYYY-MM-DD");

      const holiday = this.holidays.find((h) => h.date === dateString);

      if (holiday && !holiday.allow_job_assign) {
        return false;
      }

      return true;
    },
    // getNextAvailableDate(startDate = null) {
    //   let checkDate = startDate ? moment(startDate) : moment();

    //   // Look for the next available date (max 30 days to avoid infinite loop)
    //   for (let i = 0; i < 31; i++) {
    //     const dateString = checkDate.format('YYYY-MM-DD');
    //     const holiday = this.holidays.find(h => h.date === dateString);

    //     // If no holiday or holiday allows job assignment, this date is available
    //     if (!holiday || holiday.allow_job_assign) {
    //       return dateString;
    //     }

    //     // Move to next day
    //     checkDate.add(1, 'day');
    //   }

    //   // Fallback to current date if no available date found
    //   return moment().format('YYYY-MM-DD');
    // },

    // // Update schedule dates to skip holidays
    // updateScheduleDatesToSkipHolidays() {
    //   if (!this.oneOffSchedule.start_date || !this.oneOffSchedule.end_date) {
    //     return;
    //   }

    //   const startDate = this.oneOffSchedule.start_date;
    //   const endDate = this.oneOffSchedule.end_date;

    //   // Check if start date is on a holiday
    //   const startDateString = moment(startDate).format('YYYY-MM-DD');
    //   const startHoliday = this.holidays.find(h => h.date === startDateString);

    //   if (startHoliday && !startHoliday.allow_job_assign) {
    //     const newStartDate = this.getNextAvailableDate(startDate);
    //     this.updateScheduleState('dbOneOffSchedule.start_date', newStartDate);
    //     this.updateScheduleState('dbOneOffSchedule.end_date', newStartDate);
    //   }

    //   // Check if end date is on a holiday
    //   const endDateString = moment(endDate).format('YYYY-MM-DD');
    //   const endHoliday = this.holidays.find(h => h.date === endDateString);

    //   if (endHoliday && !endHoliday.allow_job_assign) {
    //     const newEndDate = this.getNextAvailableDate(endDate);
    //     this.updateScheduleState('dbOneOffSchedule.end_date', newEndDate);
    //   }
    // },
    showErrorIfHoliday() {
      // not in use
      if (!this.oneOffSchedule.start_date || !this.oneOffSchedule.end_date) {
        return;
      }

      const startDate = this.oneOffSchedule.start_date;
      // const endDate = this.oneOffSchedule.end_date;

      // Check if start date is on a holiday
      const startDateString = moment(startDate).format("YYYY-MM-DD");
      const startHoliday = this.holidays.find(
        (h) => h.date === startDateString
      );

      if (startHoliday && !startHoliday.allow_job_assign) {
        ErrorEventBus.$emit(
          "update:error",
          "You can't create the Visit on Holiday!"
        );
      }

      // // Check if end date is on a holiday
      // const endDateString = moment(endDate).format('YYYY-MM-DD');
      // const endHoliday = this.holidays.find(h => h.date === endDateString);

      // if (endHoliday && !endHoliday.allow_job_assign) {
      //   ErrorEventBus.$emit("update:error", "You can't create the Visit on Holiday!");
      // }
    },
    formatDate(date) {
      if (moment(date).isValid()) {
        return moment(date).format("DD MMMM YYYY");
      }
    },
    updateScheduleState(key, value) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      this.updateDefaultDate();
      this.scheduleKey++;
    },
    updateDefaultDate() {
      this.$nextTick(() => {
        this.$store.dispatch(UPDATE_DEFAULT_DATE, "one-off");
      });
    },
    updateCalendar() {
      this.$store.commit(UPDATE_CALENDAR_ACTION);
    },
  },
  mounted() {
    this.updateDefaultDate();
    // this.$nextTick(() => {
    // this.showErrorIfHoliday();
    // this.updateScheduleDatesToSkipHolidays();
    // });
  },
  components: {
    ScheduleTeam,
    Calendar,
    TimePicker,
    DatePicker,
  },
  computed: {
    ...mapGetters(["vShowCalendar", "oneOffSchedule", "jobLoading"]),
    /*  todayTime() {
      return moment(this.oneOffSchedule.start_date).format("hh:mm A");
    }, */
    /* updatedDate() {
      return moment(this.oneOffSchedule.start_time, "hh:mm A")
        .add(60, "minutes")
        .format("hh:mm A");
    }, */
  },
};
</script>
